export default "__VITE_ASSET__c5bd5b3a__"